import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { InlineGridField, InlineGrid } from '@components/form';
import { operationalWarehouseFormHistoriesColumns } from '@modules/operationalWarehouse/_operationalWarehouseColumns';
import { operationalWarehouseFormHistoriesForm } from './operationalWarehouseFormHistoriesForm';

const View: React.SFC<any> = () => (
  <Grid fluid={true}>
    <Row>
      <Col className="grid-system-margin" />
    </Row>

    <Row>
      <Col md={12}>
        <InlineGridField
          component={InlineGrid}
          name="histories"
          Form={operationalWarehouseFormHistoriesForm}
          columns={operationalWarehouseFormHistoriesColumns}
          showCheckboxes={false}
          deleting={false}
          editing={true}
          adding={false}
          sort="created"
          version="3"
        />
      </Col>
    </Row>

    <Row>
      <Col className="grid-system-margin" />
    </Row>
  </Grid>
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/operationalWarehouse/operationalWarehouseFormHistories.tsx